import useAdditionalGroupsSelect from 'modules/additional-groups/hooks/use-additional-groups-select';
import useEditAdditional, {
  EditAdditionalProps,
} from 'modules/additionals/hooks/use-edit-additional';
import {translatedAdditionalProps} from 'modules/additionals/types';
import additionalsKeys from 'modules/additionals/util/additionals-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditAdditional: React.FC = () => {
  const {id} = useParams();
  const {getInput, getSwitch, getSelect, getTextArea, getPriceInput} =
    useFormInputs<EditAdditionalProps>();
  const {data, isLoading} = useAdditionalGroupsSelect();

  return (
    <Edition<EditAdditionalProps>
      titleBar={{title: 'Editar adicional'}}
      inputs={[
        getInput({
          name: 'name',
        }),
        getTextArea({name: 'description'}),
        getSwitch({
          name: 'active',
        }),
        getPriceInput({name: 'price'}),
        getSelect({name: 'additionalGroupId', data, isLoading}),
      ]}
      detailsUrl={`/additionals/${id}`}
      onSubmit={() => useEditAdditional(id!)}
      translationKey={translatedAdditionalProps}
      queryKey={additionalsKeys.details(id!)}
    />
  );
};

export default EditAdditional;
